(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  var useCache = 1;

  app.service('overviewApi', [
    '$http',
    '$q',
    function($http, $q) {

      this.getAdvertisers = function() {
        var url = '/demandmgr/advertiser/list';

        url = url + '?sortField=name';
        url = url + '&sortOrder=asc';
        url = url + '&search=';
        url = url + '&pageNumber=0';
        url = url + '&pageSize=-1';
        url = url + '&withExtraData=0';
        url = url + '&useCache=' + useCache;


        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

      this.getIos = function(advertiserId) {
        var url = '/demandmgr/insertion-order/list';

        url = url + '?sortField=name';
        url = url + '&sortOrder=asc';
        url = url + '&search=';
        url = url + '&pageNumber=0';
        url = url + '&pageSize=-1';
        url = url + '&withExtraData=0';
        url = url + '&useCache=' + useCache;


        if (advertiserId && advertiserId !== '*') {
          url = url + '&advertiserId=' + advertiserId;
        }

        return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) {
              resolve(res.data);
            },
            function(res) {
              console.log(res);
              reject();
            }
          );
        });
      };

      this.getCampaigns = function(advertiserId, io) {
        var url = '/demandmgr/campaign/list';

        url = url + '?sortField=name';
        url = url + '&sortOrder=asc';
        url = url + '&search=';
        url = url + '&pageNumber=0';
        url = url + '&pageSize=-1';
        url = url + '&withExtraData=0';
        url = url + '&useCache=' + useCache;

        if (advertiserId && advertiserId !== '*') {
          url = url + '&advertiserId=' + advertiserId;
        }

        if (io && io !== '*') {
          url = url + '&insertionOrder=' + io;
        }

        return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) {
              resolve(res.data);
            },
            function(res) {
              console.log(res);
              reject();
            }
          );
        });
      };

      var getDatesFromRange = function(range) {
        var ret = {
          start: null,
          end: null,
        };

        switch (range) {
          case 'this_week':
            ret['end'] = new Date();
            var day = ret['end'].getDay(),
              diff = ret['end'].getDate() - day + (day == 0 ? -6 : 1);
            var d = new Date(ret['end'].getTime());
            ret['start'] = new Date(d.setDate(diff));
            break;
          case 'last_7_days':
            ret['end'] = new Date();
            var d = new Date(ret['end'].getTime());
            ret['start'] = new Date(d.setDate(d.getDate() - 7));
            break;
          case 'last_14_days':
            ret['end'] = new Date();
            var d = new Date(ret['end'].getTime());
            ret['start'] = new Date(d.setDate(d.getDate() - 14));
            break;
          case 'last_30_days':
            ret['end'] = new Date();
            var d = new Date(ret['end'].getTime());
            ret['start'] = new Date(d.setDate(d.getDate() - 30));
            break;
          case 'last_week':
            var d = new Date();
            var day = d.getDay(),
              diff = d.getDate() - day + (day == 0 ? -7 : 0);
            ret['end'] = new Date(d.setDate(diff));
            ret['start'] = new Date(d.setDate(d.getDate() - 7));
            break;
          case 'last_2_weeks':
            var d = new Date();
            var day = d.getDay(),
              diff = d.getDate() - day + (day == 0 ? -7 : 0);
            ret['end'] = new Date(d.setDate(diff));
            ret['start'] = new Date(d.setDate(d.getDate() - 14));
            break;
          case 'this_month':
            ret['end'] = new Date();
            ret['start'] = new Date(
              ret['end'].getFullYear(),
              ret['end'].getMonth(),
              1
            );
            break;
          case 'last_month':
            var d = new Date();
            ret['end'] = new Date(d.getFullYear(), d.getMonth(), 0);
            ret['start'] = new Date(d.getFullYear(), d.getMonth() - 1, 1);
            break;
          default:
            ret['end'] = new Date();
            var d = new Date(ret['end'].getTime());
            ret['start'] = new Date(d.setDate(d.getDate() - 7));
            break;
        }

        return ret;
      };

      this.getDatesFromRange = function(range) {
        return getDatesFromRange(range);
      }

      var getUrlParams = function(range, advertiserId, io, campaign) {
        var url = '';
        var dates = getDatesFromRange(range);
        url =
          url +
          'start=' +
          dates['start'].toISOString().slice(0, 10) +
          '&end=' +
          dates['end'].toISOString().slice(0, 10);


        if (advertiserId && advertiserId !== '*') {
          url = url + '&advertiserId=' + advertiserId;
        }

        if (io && io !== '*') {
          url = url + '&insertionOrder=' + io;
        }

      //remove *
        var campaignFilter = [];
        campaign.forEach(function(item, i, arr) {
          if (item != '*') {
            campaignFilter.push(item);
          }
        });
        if (campaignFilter.length > 0) {
          url = url + '&campaignIds=' + campaignFilter;
        }


        // USE user timezone  query if campaign or io selected
        if (campaign !== '*' || io !== '*'){
            url = url + '&utz=1';
        }

        return url;
      };

      var getUrl = function(range, advertiserId, io, campaign) {

          if (campaign !== '*' || io !== '*'){
              return (
                  '/reportsvwr/api?req=campaignDeliveryHourly&_f=json&' +
                  getUrlParams(range, advertiserId, io, campaign)
              );
          } else {
              return (
                  '/reportsvwr/api?req=campaignDeliveryDaily&_f=json&useCache=' + useCache + '&' +
                  getUrlParams(range, advertiserId, io, campaign)
              );
          }
      };

      this.getUpcoming = function(range, advertiserId, io, campaign) {
        var url =
          '/demandmgr/upcoming?' +
          getUrlParams(range, advertiserId, io, campaign);

        return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) {
              resolve(res.data);
            },
            function(res) {
              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

      this.getTotals = function(range, advertiserId, io, campaign) {
        var url = getUrl(range, advertiserId, io, campaign) + '&groupBy=';


        return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) {
              resolve(res.data);
            },
            function(res) {
              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

      this.getSeries = function(range, advertiserId, io, campaign) {
        var url = getUrl(range, advertiserId, io, campaign);
        if (campaign !== '*' || io !== '*'){
            url = url + '&groupBy=userTimezoneDate&sortField=userTimezoneDate';
        } else {
            url = url + '&groupBy=ref_date&sortField=ref_date';
        }


        return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) {
              resolve({
                data: res.data,
                start: getDatesFromRange(range)['start'].getTime(),
                end: getDatesFromRange(range)['end'].getTime(),
              });
            },
            function(res) {
              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

      this.getPies = function(range, advertiserId, io, campaign) {
        var url =
          getUrl(range, advertiserId, io, campaign) + '&groupBy=dvt';

        return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) {
              resolve(res.data);
            },
            function(res) {
              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

      this.getDeliveredCampaigns = function(range, advertiserId, io, campaign, useCdp) {
        var url = useCdp ?
            '/demandmgr/deliveredCampaigns?' + getUrlParams(range, advertiserId, io, campaign) :
            getUrl(range, advertiserId, io, campaign) + '&groupBy=cid&extended=1&pageSize=10';

        return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) {
              resolve(res.data);
            },
            function(res) {
              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

      this.getDeliveredCreatives = function(
        range,
        advertiserId,
        io,
        campaign,
        page
      ) {
        var url =
          getUrl(range, advertiserId, io, campaign) +
          '&groupBy=ad&extended=1&pageSize='+page.size+'&pageNum='+page.number+'&paging=true';

          url = url + '&sortField=n_impression';
          url = url + '&sortOrder=desc';

        return $q(function(resolve, reject) {
          $http.get(url).then(
            function(res) {
              resolve(res.data);
            },
            function(res) {
              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

    },
  ]);
})(window.angular);
